import get from '../get'

function mapFields (paths) {
  const isPathsArray = Array.isArray(paths)
  const keys = Object.keys(paths)

  return keys.reduce((mapped, key) => {
    const path = paths[key]

    let mappedKey = key
    if (isPathsArray) {
      let fieldName
      if (typeof path === 'string') {
        [fieldName] = path.split('.')
      } else {
        [fieldName] = path
      }
      mappedKey = `${fieldName}Field`
    }

    const computedProp = {
      get () {
        return get(this.fields, path, null)
      }
    }

    mapped[mappedKey] = computedProp
    return mapped
  }, {})
}

export default mapFields
